import { render } from "./ContactForm.vue?vue&type=template&id=317c952d"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=317c952d&lang=scss"
script.render = render

export default script